import { Employee } from "../../process/types/processTypes";
import { Company } from "../../setups/types/setupTypes";

export enum ComplainStatus {
  opened = "opened",
  on_process = "on_process",
  closed = "closed",
  confirmed = "confirmed",
  reopened = "reopened",
}

export enum ComplainTypes {
  did_not_call = "did_not_call",
  status_not_known = "status_not_known",
  not_comfortable_with_employers = "not_comfortable_with_employers",
  other = "other",
}

export enum ComplainPriority {
  low = "low",
  medium = "medium",
  high = "high",
  severe = "severe",
}

export type ComplaintStatusHistoryEntry = {
  status: ComplainStatus;
  changedByEmail: string;
  changedAt: Date | string;
  remark?: string;
};

export type Complaint = {
  _id?: string;
  employee: Employee;
  company?: Company;
  type: ComplainTypes;
  priority: ComplainPriority;
  status: ComplainStatus;
  subject: string;
  description: string;
  openedByEmail: string;
  resolutionNotes?: string;
  statusHistory: ComplaintStatusHistoryEntry[];
  closedAt?: Date | string;
  confirmedAt?: Date | string;
  createdAt?: Date | string;
  updatedAt?: Date | string;
};

export type ComplaintsWithCount = {
  totalCount: number;
  complaints: Complaint[];
};

export type ComplaintArgs = {
  skip: number;
  take: number;
  status?: ComplainStatus;
  priority?: ComplainPriority;
  type?: ComplainTypes;
  employeeId?: string;
  searchText?: string;
};

export type ComplaintInput = {
  _id?: string;
  employeeId?: string;
  type?: ComplainTypes;
  priority?: ComplainPriority;
  subject?: string;
  description?: string;
  syncEmployeeStatus?: boolean;
};

export type UpdateComplaintStatusInput = {
  id: string;
  status: ComplainStatus;
  resolutionNotes?: string;
  syncEmployeeStatus?: boolean;
};

export type ComplaintState = {
  complaintsWithCount: ComplaintsWithCount;
  selectedComplaint: Complaint | null;
  loading: "idle" | "pending";
  success: { message: string; setupType?: string } | null;
  error: { message: string } | null;
};
